import { useEffect, useState, useRef } from "react"
import { useTranslation } from "react-i18next";
import { Row, Col, Modal, Button } from '../../ui/ot'
import StaffPatronProgressTable from "./staff_patron_progress_table";
const StaffPatronProgressModal = ({
    keyPrefix = 'library.bookdetail',
    propsOpen = null,
    propsSetOpen=()=>{},
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }
    return (<Row>
        <Col  >
            <Button onClick={() => {
               showModal()
            }}>
                查看匯入進度
            </Button>
            <Modal
                title
                children
                open={propsOpen === null ? isModalOpen : propsOpen}
                onClose={closeModal}
                closeText="關閉"
                close={true}
                width={1200}
            >
                <Row gutter={[8, 8]}>
                    <Col span={24}>
                    </Col>
                    <Col span={24}>
                        <StaffPatronProgressTable />
                    </Col>
                </Row>
            </Modal>
        </Col>
    </Row >)
}

export default StaffPatronProgressModal